function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M191 219.72V198.28L172.58 194.19C171.01 187.472 168.355 181.054 164.72 175.19L174.85 159.28L159.7 144.15L143.79 154.27C137.919 150.651 131.503 148.001 124.79 146.42L120.71 128H99.28L95.18 146.42C88.4661 147.999 82.0505 150.65 76.18 154.27L60.31 144.15L45.15 159.31L55.27 175.22C51.6379 181.085 48.9864 187.502 47.42 194.22L29 198.28V219.72L47.42 223.81C48.9885 230.527 51.6398 236.945 55.27 242.81L45.15 258.7L60.31 273.87L76.2 263.75C82.0705 267.37 88.4861 270.021 95.2 271.6L99.3 290H120.73L124.83 271.6C131.543 270.019 137.959 267.369 143.83 263.75L159.74 273.87L174.89 258.7L164.76 242.8C168.393 236.935 171.048 230.518 172.62 223.8L191 219.72ZM110 250.65C101.765 250.648 93.716 248.204 86.8698 243.628C80.0237 239.052 74.6881 232.549 71.5377 224.94C68.3873 217.332 67.5636 208.96 69.1706 200.884C70.7776 192.808 74.7432 185.389 80.5661 179.566C86.3889 173.743 93.8076 169.778 101.884 168.171C109.96 166.564 118.332 167.387 125.94 170.538C133.549 173.688 140.052 179.024 144.628 185.87C149.204 192.716 151.648 200.765 151.65 209C151.653 214.47 150.577 219.887 148.485 224.942C146.393 229.996 143.325 234.589 139.457 238.457C135.589 242.325 130.996 245.393 125.942 247.485C120.887 249.577 115.47 250.653 110 250.65V250.65Z",
  className: "extra-color-2-darkened-1"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M95 209.5H125",
  className: "extra-color-2-darkened-1-stroke",
  strokeWidth: 7,
  strokeMiterlimit: 10
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M439 96.06V400H159V96.05C159.013 93.3932 160.078 90.8498 161.961 88.9759C163.845 87.1019 166.393 86.05 169.05 86.05H428.92C431.582 86.0473 434.137 87.0988 436.026 88.9747C437.915 90.8505 438.984 93.3979 439 96.06V96.06Z",
  className: "primary-lightened-1"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M234 300.5H347",
  className: "primary-stroke",
  strokeWidth: 7,
  strokeMiterlimit: 10
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M192 300.5H214",
  className: "primary-stroke",
  strokeWidth: 7,
  strokeMiterlimit: 10
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M192 142H332",
  className: "primary-stroke",
  strokeWidth: 6,
  strokeMiterlimit: 10,
  strokeDasharray: "10.79 10.79"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M234 330.5H347",
  className: "primary-stroke",
  strokeWidth: 7,
  strokeMiterlimit: 10
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M192 330.5H214",
  className: "primary-stroke",
  strokeWidth: 7,
  strokeMiterlimit: 10
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M251.74 193C245.983 187.246 238.41 183.666 230.309 182.871C222.209 182.075 214.083 184.112 207.317 188.636C200.551 193.16 195.562 199.89 193.202 207.679C190.841 215.469 191.255 223.836 194.372 231.354C197.489 238.873 203.116 245.078 210.296 248.913C217.475 252.748 225.762 253.974 233.744 252.384C241.726 250.793 248.91 246.484 254.072 240.191C259.233 233.898 262.053 226.009 262.05 217.87C262.054 213.25 261.146 208.674 259.376 204.406C257.607 200.138 255.012 196.262 251.74 193V193Z",
  className: "primary-lightened-2"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M336.2 193C330.443 187.246 322.87 183.666 314.769 182.871C306.669 182.075 298.543 184.112 291.777 188.636C285.011 193.16 280.022 199.89 277.662 207.679C275.301 215.469 275.715 223.836 278.832 231.354C281.949 238.873 287.576 245.078 294.756 248.913C301.935 252.748 310.222 253.974 318.204 252.384C326.186 250.793 333.37 246.484 338.532 240.191C343.693 233.898 346.513 226.009 346.51 217.87C346.515 213.25 345.607 208.674 343.838 204.406C342.069 200.137 339.473 196.261 336.2 193V193Z",
  className: "primary-lightened-2-stroke",
  strokeWidth: 7,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M308.27 222.56L379.41 151.42",
  className: "primary-stroke",
  strokeWidth: 6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M361 170H381.72L401.72 150H381V129.28L361 149.28V170Z",
  className: "primary"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M387 144H407.55L415.55 136H395V115.45L387 123.45V144Z",
  className: "primary"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M439 392H159V418H439V392Z",
  className: "primary-lightened-2"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M488.5 296V327",
  className: "extra-color-2-stroke",
  strokeWidth: 7,
  strokeMiterlimit: 10
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M474 311.5H504",
  className: "extra-color-2-stroke",
  strokeWidth: 7,
  strokeMiterlimit: 10
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M570 322.72V301.28L551.58 297.19C550.01 290.472 547.355 284.054 543.72 278.19L553.85 262.28L538.7 247.15L522.79 257.27C516.919 253.651 510.503 251.001 503.79 249.42L499.71 231H478.28L474.18 249.42C467.466 250.999 461.05 253.65 455.18 257.27L439.29 247.15L424.13 262.31L434.25 278.22C430.618 284.085 427.966 290.502 426.4 297.22L408 301.28V322.72L426.42 326.81C427.989 333.527 430.64 339.945 434.27 345.81L424.15 361.71L439.31 376.88L455.2 366.76C461.07 370.38 467.486 373.031 474.2 374.61L478.3 393.01H499.73L503.83 374.61C510.543 373.029 516.959 370.379 522.83 366.76L538.74 376.88L553.89 361.71L543.76 345.81C547.393 339.945 550.048 333.528 551.62 326.81L570 322.72ZM489 353.65C480.765 353.648 472.716 351.204 465.87 346.628C459.024 342.052 453.688 335.549 450.538 327.94C447.387 320.332 446.564 311.96 448.171 303.884C449.778 295.808 453.743 288.389 459.566 282.566C465.389 276.743 472.808 272.778 480.884 271.171C488.96 269.564 497.332 270.387 504.94 273.538C512.549 276.688 519.052 282.024 523.628 288.87C528.204 295.716 530.648 303.765 530.65 312C530.653 317.47 529.577 322.887 527.485 327.942C525.393 332.996 522.325 337.589 518.457 341.457C514.589 345.325 509.996 348.393 504.942 350.485C499.887 352.577 494.47 353.653 489 353.65V353.65Z",
  className: "extra-color-2"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 600,
    height: 500,
    viewBox: "0 0 600 500",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

export default __webpack_public_path__ + "static/media/newly_assigned_objective.cc2d9837.svg";
export { SvgComponent as ReactComponent };